<template lang="html">
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.85 59.57"><title>Untitled-1</title><path d="M37.13,2.22H33.69A24.25,24.25,0,0,0,9.57,26.41v1.11A24.14,24.14,0,0,0,22,48.57a19.74,19.74,0,0,0,5.15,2.14v11S54.43,65,54.43,32.24V7.36S46.34,2.56,37.13,2.22Z" transform="translate(-9.57 -2.22)" style="fill:#3a62cc"/></svg>
</template>

<script>
export default {
}
</script>
